import { render, staticRenderFns } from "./UserJoinClassForm.vue?vue&type=template&id=bb0e95c8"
import script from "./UserJoinClassForm.vue?vue&type=script&lang=js"
export * from "./UserJoinClassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports